import { Question } from '../types';

/**
 * Returns question option values in display order (from QuestionOption relation).
 * Use this instead of legacy answerOptions everywhere.
 */
export function getQuestionOptionsList(question: Question): string[] {
  if (!question.options || question.options.length === 0) return [];
  return [...question.options]
    .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
    .map(o => o.optionValue);
}

/**
 * For APIs/scaleLabels that expect legacy shape { options: string[] }
 */
export function getQuestionOptionsAsLegacyShape(question: Question): { options: string[] } | null {
  const list = getQuestionOptionsList(question);
  return list.length > 0 ? { options: list } : null;
}

/**
 * Build option value -> score map from question.scoringRuleEntries (schema-aligned).
 * Prefer this over question.scoringRules so frontend matches API/schema.
 */
export function getScoringRulesMap(question: Question): Record<string, number> {
  const entries = question.scoringRuleEntries;
  if (entries && entries.length > 0) {
    const map: Record<string, number> = {};
    for (const e of entries) {
      const score = typeof e.score === 'number' ? e.score : Number(e.score);
      if (!Number.isNaN(score)) map[e.answerValue] = score;
    }
    return map;
  }
  return (question.scoringRules as Record<string, number>) || {};
}
